<template>
  <div class="w-full h-full flex flex-row">
    <Navigation title="Zeiterfassung" ref="nav"/>
    <div class="flex flex-grow flex-col relative">
      <Header title="Zeiterfassung" class="flex-grow" @toggleMenu="$refs.nav.toggleMenu()"/>
      <div id="content" class="w-full h-full overflow-y-auto">
        <div class="w-full h-full p-4">
        <TimeTrackingUser />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TimeTrackingUser from '@/components/TimeTrackingUser.vue';
import Header from '@/components/Header.vue'
import Navigation from '@/components/Navigation.vue'
export default {
  name: 'HomeView',
  components: {
    Navigation,
    Header,
    TimeTrackingUser
  }
}
</script>
